export default __webpack_public_path__ + "static/6-dc10ce696bce6a1fee34d6ac18560352.svg";